import { useContext, useEffect, useState } from "react";
import { TeamsFxContext } from "../context/Context";
import StatsDiv from "../components/StatsDiv";
import Grid from '@mui/material/Grid2';
import { Typography, TextField, Box, InputAdornment, OutlinedInput, FormControl } from "@mui/material";
import { Colors } from "../components/style";
import TicketsTable from "../components/ticketsTable";
import "./Dashboard.css"
import GetInfoOperatorLogged from "../components/userInfo";
import { useNavigate, useLocation } from 'react-router-dom'; // Aggiungiamo useLocation
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import ColorModeIconDropdown from "../shared-theme/ColorModeIconDropdown";
import TicketSection from "../components/ticketsSection";

console.log("Caricamento Nuova Dashboard 2")

const Dashboard = () => {
  const { apiUrl } = useContext(TeamsFxContext);
  const location = useLocation(); // Hook per ottenere la location corrente
  const navigate = useNavigate();

  // 🔹 SALVATAGGIO AUTOMATICO DELLA PAGINA CORRENTE
  useEffect(() => {
    // Salva la pagina corrente nel localStorage quando il componente si monta
    localStorage.setItem('last_opened_page', location.pathname);
    console.log('Dashboard: Pagina salvata ->', location.pathname);
  }, [location]);

  //Richiamo funzione per visualizzare nome della persona loggata su Teams
  const [operatorsInfo, setOperatorsInfo] = useState([{ id: 0 }])

  //Funzione per Ottenere i tickets 
  const [tickets, setTickets] = useState([]); // I miei ticket
  const [allTickets, setAllTickets] = useState([]); // Tutti i ticket

  //Stats variables
  const [statsTicketAssToResolve, setstatsTicketAssToResolve] = useState(0)
  const [statsTicketAssSolution, setstatsTicketAssSolution] = useState(0)
  const [statsTicketAssNeedInfo, setstatsTicketAssNeedInfo] = useState(0)
  const [statsTicketAssToProcess, setstatsTicketAssToProcess] = useState(0)

  const processTickets = (tickets) => {
    let toProcessCount = 0;
    let needInfoCount = 0;
    let solutionCount = 0;

    // Itera sui ticket e conta in base aion_process_status
    tickets.forEach((ticket) => {
      switch (ticket.aion_process_status) {
        case 'toProcess':
          toProcessCount++;
          break;
        case 'need_info':
          needInfoCount++;
          break;
        case 'solution':
          solutionCount++;
          break;
        default:
          break;
      }
    });

    // Aggiorna gli stati
    setstatsTicketAssToProcess(toProcessCount);
    setstatsTicketAssNeedInfo(needInfoCount);
    setstatsTicketAssSolution(solutionCount);
    setstatsTicketAssToResolve(tickets.length); // Numero totale di ticket
  };

  // Funzione per ottenere le informazioni dell'operatore loggato
  const getOperatorsInfo = async () => {
    const operatorInfo = await GetInfoOperatorLogged();
    console.log(operatorInfo)
    setOperatorsInfo(operatorInfo); // Imposta lo stato con le info dell'operatore
  };

  const getTickets = async (email) => {
    try {
      // 1️⃣ Recupero ticket dell'operatore
      const operatorResponse = await fetch("https://mapei.aion-asa.com/api/get_operator_tickets/", {
        method: "POST",
        headers: {
          "accept": "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            user_mail: email
          }
        }),
      });

      const operatorData = await operatorResponse.json();
      // console.log("RESPONSE OPERATOR", operatorData);

      if (operatorData.code === 200) {
        setTickets(operatorData.tickets); // Ticket dell'utente
        processTickets(operatorData.tickets);
      } else {
        throw operatorData;
      }

      // 2️⃣ Recupero tutti i ticket
      const allResponse = await fetch("https://mapei.aion-asa.com/api/get_all_tickets/", {
        method: "POST",
        headers: {
          "accept": "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            user_mail: email
          }
        }),
      });

      const allData = await allResponse.json();

      if (allData.code === 200) {
        setAllTickets(allData.tickets); // Salva tutti i ticket
      } else {
        throw allData;
      }

    } catch (error) {
      console.error("ERROR GET TICKETS\n", error);
    } finally {
      console.log("END CALLING SERVER");
    }
  };

  // Effetto per ottenere le info dell'operatore al primo render
  useEffect(() => {
    const fetchData = async () => {
      await getOperatorsInfo(); // Ottieni le info dell'operatore
    };
    fetchData();
  }, []);

  // Effetto per chiamare getTickets una volta che operatorsInfo è stato aggiornato
  useEffect(() => {
    if (operatorsInfo.length > 0) {
      getTickets(operatorsInfo[0].email); // Chiamata a getTickets con l'email dell'operatore
    }
  }, [operatorsInfo]);

  //AUTO FETCH 
  useEffect(() => {
    if (operatorsInfo.length == 0) return;

    getTickets(operatorsInfo[0].email);
    const intervalId = setInterval(() => getTickets(operatorsInfo[0].email), 5000);

    return () => clearInterval(intervalId);
  }, [operatorsInfo]);

  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (event) => {
    if (event.key === 'Enter') {
      if (searchTerm.trim()) {
        // 🔹 Prima di navigare, salviamo esplicitamente dove stiamo andando
        const chatPath = `/Chat/${searchTerm}/${operatorsInfo[0]?.mapedesk_id || ''}`;
        localStorage.setItem('last_opened_page', chatPath);
        console.log('Navigando verso Chat, pagina salvata ->', chatPath);
        
        // Reindirizza alla pagina della chat con il ticket_id
        navigate(chatPath);
      }
    }
  };

  return (
    <>
      {/* EXAGON */}
      <div
        className="blobDashboard"
        style={{
          backgroundImage: "url('https://aion-asa.com/images/teams/logo_white.png')",
          position: "fixed",
          width: "75%",
          height: "19rem",
          top: "30%",
          left: "50%",
          transform: "translate(-50%, -50%)", // Centers the element
          backgroundRepeat: "no-repeat", // Fixed typo "norepeat" -> "no-repeat"
          zIndex: 0,
          backgroundSize: "contain",
          backgroundPosition: "center",
          opacity: 0.4
        }}
      ></div>

      {/* DIV HEADER */}
      <div style={{ position: "relative", zIndex: 1 }}>

        {/* DIV WELCOME */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ padding: '1rem' }}
        >
          {/* Testo a sinistra */}
          <Typography variant="h4" color={Colors.white} style={{ fontWeight: 'bold' }}>
            Ciao {operatorsInfo.length > 0 && operatorsInfo[0].name}, <br />
            Ecco la tua Dashboard
          </Typography>

          {/* Barra di ricerca a destra */}
          <Box
            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
          >
            <FormControl sx={{ width: { xs: '100%', md: '100%' } }} variant="outlined">
              <OutlinedInput
                sx={{ ml: 1, flex: 1 }}
                placeholder="Cerca Ticket ID o Chat ID"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleSearch} // Gestisce il submit quando si preme "Enter"
                endAdornment={
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                }
                inputProps={{
                  'aria-label': 'search',
                }}
              />
            </FormControl>
            <ColorModeIconDropdown />
          </Box>
        </Box>

        {/* DIV STATS */}
        <Grid
          container
          spacing={3}
          sx={{
            marginTop: "2rem",
            zIndex: 2,
            position: "relative",
            justifyContent: "space-between"
          }}
        >
          <Grid item size xs={12} md={4} lg={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <StatsDiv title={"Ticket assegnati da risolvere"} number={statsTicketAssToResolve} style={null} index={0} />
          </Grid>
          <Grid item xs={12} md={4} lg={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <StatsDiv title={"Ticket assegnati con possibili soluzioni"} number={statsTicketAssSolution} index={1} />
          </Grid>
          <Grid item xs={12} md={4} lg={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <StatsDiv title={"Ticket non chiari o non processati"} number={statsTicketAssNeedInfo} index={2} />
          </Grid>
        </Grid>
      </div>

      <TicketSection myTickets={tickets} allTickets={allTickets} operator_id={operatorsInfo[0]?.mapedesk_id} />
    </>
  );
}

export default Dashboard